import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const sliderApi = createApi({
  reducerPath: 'sliderApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Slider'],
  endpoints: (builder) => ({
    getSliders: builder.query({
      query: (page = 1) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/slider',
          method: 'GET',
          params: { page, 'access-token': token },
        };
      },
      providesTags: ['Slider'],
    }),
    addSlider: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/add-slider',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Slider'],
    }),
    updateSlider: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/update-slider',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Slider'],
    }),
    deleteSlider: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/delete-slider',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['Slider'],
    }),
  }),
});

export const {
  useGetSlidersQuery,
  useAddSliderMutation,
  useUpdateSliderMutation,
  useDeleteSliderMutation,
} = sliderApi;
